
        Component.define('modal-search', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $btnClose       = $('.btn-close');

$btnClose.on('click', function(){
    $('.wrapper-modal').removeClass('open');
});
        });